<template lang="pug">
  a.single-column(:href="link")
    .single-column--image
      img(v-lazy="sizedImage" alt="")
    p.single-column--title.subtitle {{ title }}
</template>

<script>
  import { getSizedImageUrl } from 'scripts/helpers/images.js';

  export default {
    name: 'SingleColumn',
    props: {
      image: String,
      title: String,
      link: String
    },
    computed: {
      sizedImage() {
        return getSizedImageUrl(this.image, '500x');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .single-column {
    display: block;
    margin-bottom: 9px;

    @include tablet-up {
      margin-bottom: 0;
    }

    &--image {
      position: relative;
      overflow: hidden;

      // force square aspect ratio
      &:after {
        content: "";
        display: block;
        padding-bottom: 100%;
      }

      // keep squares from taking up too much vertical space on mobile
      @include mobile-only {
        max-width: 500px;
        margin-left: auto;
        margin-right: auto;
      }

      img {
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        object-position: center center;
        object-fit: cover;
        transition: transform 0.2s ease-out;
      }
    }

    &:hover &--image img {
      transform: scale(1.1);
      transition: transform 0.3s ease-out;
    }

    &--title {
      margin-top: 9px;
      margin-bottom: 0;
      font-family: $font-header--main;
      font-size: 14px;
      font-weight: 900;
      letter-spacing: 3px;
      line-height: 18px;
      text-transform: uppercase;
      text-align: center;

      @include tablet-up {
        margin-top: 18px;
      }
    }
  }
</style>
